import { ChangeDetectionStrategy, Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IIncidentCode, IncidentCodeService } from '@shared/services/incident-code-service';
import { map, Observable, startWith } from 'rxjs';

@Component({
	selector: 'app-update-incident-code',
	templateUrl: './update-incident-code.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class UpdateIncidentCodeComponent implements OnInit {
	@Output() updated: EventEmitter<any> = new EventEmitter();
	incidentCode: IIncidentCode;
	form: FormGroup;
	loading: boolean = false;
	httpError: string = '';
	filteredGroups: Observable<string[]>;
	groupControl: FormControl<string>;

	constructor(
		@Inject(MAT_DIALOG_DATA)
		public dialogData: {
			incidentCode: IIncidentCode;
			incidentCodeGroups: string[];
		},
		public dialogRef: MatDialogRef<UpdateIncidentCodeComponent>,
		private service: IncidentCodeService,
		private fb: FormBuilder,
	) {
		this.incidentCode = { ...dialogData.incidentCode };
	}

	ngOnInit(): void {
		this.initializeForm();
		this.groupControl = this.controls['group'] as FormControl<string>;
		this.filteredGroups = this.groupControl.valueChanges.pipe(
			startWith(''),
			map((value) => {
				const filterValue = value.toLowerCase();
				return this.dialogData.incidentCodeGroups.filter((group) => group.toLowerCase().includes(filterValue));
			}),
		);
	}

	initializeForm(): void {
		this.form = this.fb.group({
			alias: [{ value: this.incidentCode.alias, disabled: true }, [Validators.required, Validators.maxLength(255)]],
			name: [this.incidentCode.name, [Validators.required, Validators.maxLength(255)]],
			group: [this.incidentCode.group, [Validators.required, Validators.maxLength(255)]],
			isActive: [this.incidentCode.isActive],
		});
		this.subscribeToFormChanges();
	}

	private subscribeToFormChanges(): void {
		this.form.valueChanges.subscribe((value) => {
			Object.keys(value).forEach((key) => {
				if (key in this.incidentCode) {
					this.incidentCode[key] = value[key];
				}
			});
		});
	}

	get controls() {
		return this.form.controls;
	}

	onCancel = () => this.dialogRef.close();

	async onSave() {
		if (this.loading) return;
		this.httpError = '';

		if (this.form.valid) {
			this.loading = true;
			this.service.update(this.incidentCode).subscribe({
				next: (response) => {
					this.updated.emit(response);
					this.dialogRef.close();
				},
				error: (errorResponse) => {
					this.httpError = `${errorResponse.status}`;
					this.loading = false;
				},
			});
		}
	}
}
